import { Link, useNavigate } from "react-router-dom";
import { removeUserSession, getToken, getUser } from "../../../Utils/Common";
import React, { useState } from "react";
import { useSelector, useDispatch } from "react-redux";
// import Logo from "../../../../public/logo-dark.png";
import { useLocation } from "react-router-dom";
import "./layout.css";

import {
  decrement,
  increment,
  incrementByAmount,
  incrementAsync,
  selectCount,
  setUserCredits,
} from "../../../features/counter/counterSlice";

const Layout = ({ userData }) => {
  const { pathname } = useLocation();
  const userCredits = useSelector(selectCount);
  const dispatch = useDispatch();
  let navigate = useNavigate();
  const token = getToken();
  const user = getUser();

  // console.log("userData", user);
  const handleLogout = () => {
    console.log("click me");
    removeUserSession();
    navigate("/login");
  };

  return (
    <>
      {/* New Menu */}
      {pathname === "/login" || pathname === "/signup" ? (
        <div></div>
      ) : (
        <div id="kt_header" className="header align-items-stretch">
          {/*begin::Container*/}
          <div className="container-fluid d-flex align-items-stretch justify-content-between">
            <div className="d-flex align-items-center">
              <Link to={`/`}>
                <img
                  alt="Logo"
                  src="/images/logo-dark.png"
                  className="h-50px me-5 m-logo"
                />
              </Link>
            </div>

            {/*begin::Wrapper*/}
            <div className="d-flex align-items-stretch justify-content-between flex-lg-grow-1">
              {/*begin::Navbar*/}
              <div className="d-flex align-items-stretch" id="kt_header_nav">
                {/*begin::Menu wrapper*/}
                <div
                  className="header-menu align-items-stretch"
                  data-kt-drawer="true"
                  data-kt-drawer-name="header-menu"
                  data-kt-drawer-activate="{default: true, lg: false}"
                  data-kt-drawer-overlay="true"
                  data-kt-drawer-width="{default:'200px', '300px': '250px'}"
                  data-kt-drawer-direction="end"
                  data-kt-drawer-toggle="#kt_header_menu_mobile_toggle"
                  data-kt-swapper="true"
                  data-kt-swapper-mode="prepend"
                  data-kt-swapper-parent="{default: '#kt_body', lg: '#kt_header_nav'}"
                >
                  {/*begin::Menu*/}
                  <div
                    className="menu menu-lg-rounded menu-column menu-lg-row menu-state-bg menu-title-gray-700 menu-state-title-primary menu-state-icon-primary menu-state-bullet-primary menu-arrow-gray-400 fw-bold my-5 my-lg-0 align-items-stretch"
                    id="#kt_header_menu"
                    data-kt-menu="true"
                  >
                    {/* testing menu for mobile used */}

                    {/* active menut */}
                    <div className="menu-item here show menu-lg-down-accordion me-lg-1">
                      <span className="menu-link py-3">
                        <span className="menu-title">
                          <Link
                            to={`/lingostory`}
                            className="menu-link active py-3"
                          >
                            BROWSE
                          </Link>
                        </span>
                      </span>
                    </div>

                    <span className="mt-xxl-n3 fs-3 m-display-line">
                      <strong>|</strong>
                    </span>

                    {!token ? (
                      <div className="menu-item menu-lg-down-accordion me-lg-1">
                        <span className="menu-link ms-3 py-3">
                          <span className="menu-title">
                            <Link to={`/login`} className="menu-link py-3">
                              Login
                            </Link>
                          </span>
                        </span>
                      </div>
                    ) : (
                      <>
                        {user.user_type === 1 ? (
                          <>
                            <div
                              data-kt-menu-trigger="click"
                              data-kt-menu-placement="bottom-start"
                              className="menu-item menu-lg-down-accordion me-lg-1"
                            >
                              {/* <span className="menu-link py-3"> */}
                              <span className="menu-title">
                                <Link
                                  to={`/admin/books`}
                                  className="menu-link py-6 px-8"
                                >
                                  Books
                                </Link>
                              </span>
                              {/* <span className="menu-arrow d-lg-none"></span> */}
                              {/* </span> */}
                            </div>
                            <span className="mt-xxl-n3  m-display-line">
                              <h3>|</h3>
                            </span>
                          </>
                        ) : (
                          <>
                            <div
                              data-kt-menu-trigger="click"
                              data-kt-menu-placement="bottom-start"
                              className="menu-item menu-lg-down-accordion me-lg-1"
                            >
                              {/* <span className="menu-link py-3"> */}
                              <span className="menu-title">
                                <Link
                                  to={`/library`}
                                  className="menu-link py-6 px-8"
                                >
                                  My Library
                                </Link>
                              </span>
                              {/* </span> */}
                            </div>
                          </>
                        )}

                        <div
                          data-kt-menu-trigger="click"
                          data-kt-menu-placement="bottom-start"
                          className="menu-item menu-lg-down-accordion me-lg-1 desktop-nav-admin-logout"
                        >
                          <span className="menu-link py-3">
                            <span className="menu-title">
                              {user.user_type === 1 ? (
                                <button
                                  className="menu-link py-3 logout-button"
                                  onClick={handleLogout}
                                >
                                  Logout
                                </button>
                              ) : (
                                ""
                              )}
                            </span>
                          </span>
                        </div>

                        <div className="desktop-nav">
                          <div className="d-flex align-items-stretch flex-shrink-0">
                            {/* <div className="d-flex align-items-stretch ms-1 ms-lg-3 mt-6"> */}
                            {user.user_type === 2 ? (
                              <>
                                <div className="d-flex align-items-stretch ms-1 ms-lg-3 mt-6">
                                  <h3>
                                    <Link
                                      to={`/account`}
                                      className="menu-link py-3 text-dark"
                                    >
                                      Hi, {user.name}
                                    </Link>
                                  </h3>
                                </div>

                                <div className="d-flex align-items-stretch ms-1 ms-lg-3 mt-6">
                                  <h3>
                                    |
                                    <Link
                                      to={`/buy`}
                                      className="menu-link py-3 ms-1 text-dark"
                                    >
                                      {userCredits} Credit available
                                    </Link>
                                  </h3>
                                </div>

                                <div className="d-flex align-items-stretch ms-1 ms-lg-3 mt-6">
                                  <h3>
                                    |
                                    <Link
                                      to={`/buy`}
                                      className="menu-link py-3 ms-1 text-dark"
                                    >
                                      Buy new Credits
                                    </Link>
                                  </h3>
                                </div>

                                <div className="d-flex align-items-stretch ms-1 ms-lg-3 mt-6">
                                  <h3>
                                    |
                                    <Link
                                      to={`/contact`}
                                      className="text-dark ms-1"
                                    >
                                      Help
                                    </Link>
                                  </h3>
                                </div>
                              </>
                            ) : (
                              <div className="d-flex align-items-stretch ms-1 ms-lg-3 mt-6">
                                <h3>
                                  Hi,
                                  {user.name}
                                </h3>
                              </div>
                            )}
                          </div>
                        </div>

                        <div className="mobile-nav">
                          {user.user_type === 2 ? (
                            <>
                              <div className="menu-item menu-lg-down-accordion me-lg-1">
                                <span className="menu-link py-3">
                                  <span className="menu-title">
                                    <Link
                                      to={`/account`}
                                      className="menu-link py-3"
                                    >
                                      Hi, {user.name}
                                    </Link>
                                  </span>
                                </span>
                              </div>

                              <div className="menu-item menu-lg-down-accordion me-lg-1">
                                <span className="menu-link py-3">
                                  <span className="menu-title">
                                    <Link
                                      to={`/buy`}
                                      className="menu-link py-3"
                                    >
                                      {userCredits} Credit available
                                    </Link>
                                  </span>
                                </span>
                              </div>

                              <div className="menu-item menu-lg-down-accordion me-lg-1">
                                <span className="menu-link py-3">
                                  <span className="menu-title">
                                    <Link
                                      to={`/buy`}
                                      className="menu-link py-3"
                                    >
                                      Buy new Credits
                                    </Link>
                                  </span>
                                </span>
                              </div>

                              <div className="menu-item menu-lg-down-accordion me-lg-1">
                                <span className="menu-link py-3">
                                  <span className="menu-title">
                                    <Link
                                      to={`/contact`}
                                      className="menu-link py-3"
                                    >
                                      Help
                                    </Link>
                                  </span>
                                </span>
                              </div>
                            </>
                          ) : (
                            <>
                              <div className="menu-item menu-lg-down-accordion me-lg-1">
                                <span className="menu-link py-3">
                                  {/* <span className="menu-title"> */}
                                  <Link to="#" className="menu-link py-3">
                                    Hi,
                                    {user.name}
                                  </Link>
                                  {/* </span> */}
                                </span>
                              </div>

                              <div className="menu-item menu-lg-down-accordion me-lg-1">
                                <span className="menu-link py-3">
                                  <Link
                                    to={`/logout`}
                                    className="menu-link py-3"
                                  >
                                    Logout
                                  </Link>
                                </span>
                              </div>
                              {/* s<a href="#" onClick={Logout}> Log Out in Anchor</a> */}
                              {/* <div data-kt-menu-trigger="click"
                                data-kt-menu-placement="bottom-start"
                                className="menu-item menu-lg-down-accordion me-lg-1"
                              >
                                <button
                                  className="menu-link py-3 logout-button"
                                  onClick={handleLogout}
                                >
                                  Logout
                                </button>
                              </div>

                              <div
                                data-kt-menu-trigger="click"
                                data-kt-menu-placement="bottom-start"
                                className="menu-item menu-lg-down-accordion me-lg-1"
                              >
                                <span className="menu-link py-3">
                                  <span className="menu-title">
                                    <span
                                      className="menu-link py-3"
                                      onClick={handleLogout}
                                      type="button"
                                    >
                                      Logout
                                    </span>
                                  </span>
                                </span>
                              </div> */}

                              {/* <div className="menu-item menu-lg-down-accordion me-lg-1"> */}
                              {/* <span className="menu-link py-3"> */}
                              {/* <span className="menu-title"> */}

                              {/* </span> */}
                              {/* </span> */}
                              {/* </div> */}
                            </>
                          )}
                        </div>
                      </>
                    )}
                  </div>
                  {/*end::Menu*/}
                </div>
                {/*end::Menu wrapper*/}
              </div>
              {/*end::Navbar*/}
              {/*begin::Toolbar wrapper*/}
              <div className="d-flex align-items-stretch flex-shrink-0">
                {/*begin::Header menu toggle*/}
                <div
                  className="d-flex align-items-center d-lg-none ms-2 me-n3"
                  title="Show header menu"
                >
                  <div
                    className="btn btn-icon btn-active-light-primary w-30px h-30px w-md-40px h-md-40px"
                    id="kt_header_menu_mobile_toggle"
                  >
                    {/*begin::Svg Icon | path: icons/duotune/text/txt001.svg*/}
                    <span className="svg-icon svg-icon-1">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M13 11H3C2.4 11 2 10.6 2 10V9C2 8.4 2.4 8 3 8H13C13.6 8 14 8.4 14 9V10C14 10.6 13.6 11 13 11ZM22 5V4C22 3.4 21.6 3 21 3H3C2.4 3 2 3.4 2 4V5C2 5.6 2.4 6 3 6H21C21.6 6 22 5.6 22 5Z"
                          fill="black"
                        />
                        <path
                          opacity="0.3"
                          d="M21 16H3C2.4 16 2 15.6 2 15V14C2 13.4 2.4 13 3 13H21C21.6 13 22 13.4 22 14V15C22 15.6 21.6 16 21 16ZM14 20V19C14 18.4 13.6 18 13 18H3C2.4 18 2 18.4 2 19V20C2 20.6 2.4 21 3 21H13C13.6 21 14 20.6 14 20Z"
                          fill="black"
                        />
                      </svg>
                    </span>
                    {/*end::Svg Icon*/}
                  </div>
                </div>

                {/*end::Header menu toggle*/}
              </div>

              {/*end::Toolbar wrapper*/}
            </div>

            {/*end::Wrapper*/}
          </div>

          {/*end::Container*/}
        </div>
      )}
    </>
  );
};

export default Layout;
